<script setup lang="ts">
import ParentLayout from '@vuepress/theme-default/layouts/Layout.vue'

</script>

<template>
    <ParentLayout>
        <template #navbar-after>
            <ProfileLink />
        </template>
        <template #page-content-bottom>
            <PageContentBottom />
        </template>
    </ParentLayout>
</template>

<style lang="css">

</style>